import React, { FC } from 'react'
import _ from 'lodash'
// Components
import { field_attrs } from "components/table/lib/column-field"
import DropdownInput from "components/inputs/dropdown"
// Data
import propertyService from "data/property"
// Styles
import { H4, Label_s } from "styles/app-styles"
import { Defaults_s } from "components/property/defaults/defaults-styles"

interface DefaultsNamedItemProps {
  property: object
  inflationData: object[]
  payoutData: object[]
}

const DefaultsNamedItem: FC<DefaultsNamedItemProps> = (props) => {
  const { property, inflationData, payoutData } = props;
  const inflationOptions = inflationData.map(option => { return { label: option['code'], value: option['inflationid'] }})

  const persist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsnameditem'];
    if(field === 'increaseType' && val === "/Area/Yr Annually") {
      const inflationid = _.get(_.find(inflationOptions, (o) => o.label === '*None'), "value")
      _.set(data, "increaseInflation.inflationNamedItemId", Number(inflationid))
      _.set(data, field,val)
    } else data[field] = val
    propertyService.patch(nextProperty)
  }

  const namedItemPersist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsnameditem'];
    _.set(data, field, Number(val))
    propertyService.patch(nextProperty)
  }

  const data = property['defaultsnameditem'] || {};

  const attrs = (field) => field_attrs('property', 'defaultsnameditem')(field)(property, props)

  return property && !_.isEmpty(data) ? (
    <Defaults_s>
      <div>
        <H4>Rent</H4>
        <hr />
        <div>
          <div>
            <Label_s>Amt Type</Label_s>
            <DropdownInput
              field="rentAmtType"
              options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
              value={data['rentAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Inflation</Label_s>
            <DropdownInput
              field="rentInflation.inflationNamedItemId"
              options={inflationData.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['rentInflation']['inflationNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Increase</H4>
        <hr />
        <div>
          <div>
            <Label_s>Increase Type</Label_s>
            <DropdownInput
              field="increaseType"
              options={['% Increase Annually', '% of Market Annually', '/Area/Yr Annually']}
              value={data['increaseType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Inflation</Label_s>
            <DropdownInput
              field="increaseInflation.inflationNamedItemId"
              options={inflationOptions}
              value={data['increaseInflation']['inflationNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Free Rent</H4>
        <hr />
        <div>
          <div>
            <Label_s>Revenue</Label_s>
            <DropdownInput
              field="freeRentRevenue"
              options={['Rent', 'Rent + Recovery', 'All Revenues']}
              value={data['freeRentRevenue']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Amt Type</Label_s>
            <DropdownInput
              field="freeRentAmtType"
              options={['Mos', 'Mos/Yr']}
              value={data['freeRentAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Tenant Capital</H4>
        <hr />
        <div>
          <div>
            <Label_s>TI: Amt Type</Label_s>
            <DropdownInput
              field="tiAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ]}
              value={data['tiAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>TI: Payout</Label_s>
            <DropdownInput
              field="tiPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['tiPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>TI: Inflation</Label_s>
            <DropdownInput
              field="tiInflation.inflationNamedItemId"
              options={inflationData.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['tiInflation']['inflationNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>LC: Amt Type</Label_s>
            <DropdownInput
              field="lcAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ]}
              value={data['lcAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>LC: Payout</Label_s>
            <DropdownInput
              field="lcPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['lcPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>LC: Inflation</Label_s>
            <DropdownInput
              field="lcInflation.inflationNamedItemId"
              options={inflationData.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['lcInflation']['inflationNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Other Capital: Amt Type</Label_s>
            <DropdownInput
              field="ocAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ]}
              value={data['ocAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Other Capital: Payout</Label_s>
            <DropdownInput
              field="ocPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['ocPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Other Capital: Inflation</Label_s>
            <DropdownInput
              field="ocInflation.inflationNamedItemId"
              options={inflationData.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['ocInflation']['inflationNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
    </Defaults_s>
  ) : null
}

export default DefaultsNamedItem

